import React from 'react'

interface PromptInputProps {
  promptData: string
  onPromptChange: React.TextareaHTMLAttributes<HTMLTextAreaElement>['onChange']
}
export function PromptInput({ promptData, onPromptChange }: PromptInputProps) {
  return (
    <div className="relative">
      <textarea
        className="!h-96 !w-full px-4 tc-mv-question-field text-white rounded-full mt-2 outline-none"
        value={promptData}
        onChange={onPromptChange}
      />
    </div>
  )
}
